module.exports = __webpack_public_path__ + "static/thumbnail-00c60d88de87aa0849a8231f4c22c740.png";